<template>
  <div>
    <NuxtLayout #="{ showModalMessages }">
      <div class="slot-body">
        <PhotoShooting
          :card-principal="cardPrincipal"
          :ultimos-cards="ultimosCards"
          :loading="loading"
        />
        <ClientOnly>
          <BlogBlock :post-blogs="postBlogs" />
        </ClientOnly>
        <!-- No HTML do SSR também no mobile, escondido por CSS (< 770): com v-if no
             isMobile(), false no servidor, a hidratação divergia -->
        <BlockWhite class="home-blog-spacer" :styles="{ height: '700px', top: '400px' }" />
        <BannerAreaGold />
        <div class="models-section videos-section">
          <div class="dark-rounded">
            <div class="videos-gray-cap"></div>
            <CarouselModels
              :posts="posts"
              dark-background
              :section-title="translateModels.videosTitle"
              :see-all-prefix="translateModels.seeAllVideosPrefix"
              :see-all-highlight="translateModels.seeAllVideosHighlight"
            />
          </div>
        </div>
        <MakingofVideoHome
          v-if="makingOfPosts.length"
          class="makingof-video-section"
          :posts="makingOfPosts"
          see-all-route-name="language-making-of"
          :see-all-label="translateMakingOf.seeAllMakingOf"
          :section-title="translateMakingOf.makingOfTitle"
          :see-all-prefix="translateMakingOf.seeAllMakingOfPrefix"
          :see-all-highlight="translateMakingOf.seeAllMakingOfHighlight"
        />
        <div class="models-section lives-section" v-if="postsLives.length">
          <CarouselModels
            :posts="postsLives"
            card-route-name="language-modelos-name-live"
            see-all-route-name="language-lives"
            :see-all-label="translateLives.seeAllLives"
            :section-title="translateLives.livesTitle"
            :see-all-prefix="translateLives.seeAllLivesPrefix"
            :see-all-highlight="translateLives.seeAllLivesHighlight"
            dark-background
          />
        </div>
        <div class="lives-dark-block">
          <ClientOnly>
            <BannerEnsaioGratis />
          </ClientOnly>
        </div>
        <NossasBellas />
        <ColunasHome
          :title-visible="true"
          :button-mobile="true"
          :button-more="true"
        />
        <!--
        <NewsletterBox
          @showModalMessages="showModalMessages"
          v-if="!isMobile()"
        />
        -->
        <BannerFreeTour :path1="bannerFreeTour1" :path2="bannerFreeTour2" />
      </div>
    </NuxtLayout>
  </div>
</template>
<script setup lang="ts">
// SEO: página de conteúdo explícito — marcação que o Google pede para não
// classificar o site inteiro como adulto. Ver composables/useAdultRating.ts
useAdultRating();
import BlockWhite from "@/components/BlocksCustom/BlockWhite.vue";
import NewsletterBox from "@/components/HomePage/NewsletterBox.vue";
import ColunasHome from "@/components/HomePage/ColunasHome.vue";
import BannerEnsaioGratis from "@/components/HomePage/BannerEnsaioGratis.vue";
import BannerAreaGold from "@/components/HomePage/BannerAreaGold.vue";
import BannerFreeTour from "@/components/HomePage/BannerFreeTour.vue";
import CarouselModels from "@/components/HomePage/CarouselModels.vue";
import MakingofVideoHome from "@/components/HomePage/MakingofVideoHome.vue";
import NossasBellas from "@/components/HomePage/NossasBellas.vue";
import PhotoShooting from "@/components/HomePage/BannerPhotoShooting.vue";
import BlogBlock from "@/components/HomePage/BlogBlock.vue";
import { isMobile } from "@/shared/utils/mobile";
import makingOfTradutor from "@/tradutors/makingof";
import livesTradutor from "@/tradutors/lives";
import modelsTradutor from "@/tradutors/models";

import ImgFreetour1Pt from "assets/img/BannerFreeTour1BelladaSemanaPt.webp";
import ImgFreetour1PtMobile from "assets/img/BannerFreeTour1BelladaSemanaPt-mobile.webp";
import ImgFreetour1En from "assets/img/BannerFreeTour1BelladaSemanaEn.webp";
import ImgFreetour1EnMobile from "assets/img/BannerFreeTour1BelladaSemanaEn-mobile.webp";
import ImgFreetour2Pt from "assets/img/BannerFreeTour2BelladaSemanaPt.webp";
import ImgFreetour2PtMobile from "assets/img/BannerFreeTour2BelladaSemanaPt-mobile.webp";
import ImgFreetour2En from "assets/img/BannerFreeTour2BelladaSemanaEn.webp";
import ImgFreetour2EnMobile from "assets/img/BannerFreeTour2BelladaSemanaEn-mobile.webp";
import api from "~/api";
import { publicHomeHero } from "@/utils/publicHomeHero";
import { naOrigemDaApi } from "@/utils/naOrigemDaApi";
import { posterNoDominioPrincipal } from "@/utils/ensaioSSR";
import { TIMEOUT_SSR_MS } from "@/utils/ensaioSSR";

const storeLocale = localeStore();

const route = useRoute();
const canonical = useCanonicalUrl();
const router = useRouter();

// Destaque no HTML do SSR (OS v7, FE-5). Uma chamada com mobile=true, que traz
// as imagens do desktop (`home`) e as do mobile (`homeMobile`); o teaser, que
// tem URL assinada, fica para a busca do cliente. Falha não muda nada na
// página: sem o destaque, a home carrega como antes, no navegador.
const { data: destaqueSSR } = await useAsyncData(
  "home-ssr-" + route.params.language,
  async () => {
    if (import.meta.client) return null;
    try {
      const { data } = await api.get(
        `v1/home/getEssayPrimary?language=${route.params.language}&mobile=true`,
        { timeout: TIMEOUT_SSR_MS }
      );
      return {
        fixedThumb: data?.cardPincipal?.fixedThumb ?? null,
        hero: publicHomeHero(data?.cardPincipal),
      };
    } catch {
      return null;
    }
  },
  { default: () => null }
);
const heroSSR = destaqueSSR.value?.hero ?? null;

const ultimosCards = ref([]);
const cardPrincipal = ref<any>(heroSSR ?? "");
const postBlogs = ref([]);
const bannerFreeTour1 = ref<{ image?: string; url?: string }>({});
const bannerFreeTour2 = ref<{ image?: string; url?: string }>({});
const fixedThumb = ref("/favicon.ico");
const posts = ref([]);
const postsLives = ref([]);
const makingOfPosts = ref<any[]>([]);
// Com o destaque do SSR, sem o carregamento por cima da imagem (que é o LCP).
const loading = ref(!heroSSR);

const translateMakingOf = computed(() =>
  route.params.language === "pt-br" ? makingOfTradutor.portugues : makingOfTradutor.ingles
);
const translateLives = computed(() =>
  route.params.language === "pt-br" ? livesTradutor.portugues : livesTradutor.ingles
);
const translateModels = computed(() =>
  route.params.language === "pt-br" ? modelsTradutor.portugues : modelsTradutor.ingles
);

const seo = await useSeoConfig(String(route.name), String(route.params.language));

// Preload real da imagem do destaque, no <head>: uma por formato, com media.
if (heroSSR) {
  const preloads: Record<string, string>[] = [];
  if (heroSSR.home[0])
    preloads.push({
      rel: "preload",
      as: "image",
      href: heroSSR.home[0],
      media: heroSSR.homeMobile[0] ? "(min-width: 770px)" : "all",
      fetchpriority: "high",
    });
  if (heroSSR.homeMobile[0])
    preloads.push({
      rel: "preload",
      as: "image",
      href: heroSSR.homeMobile[0],
      media: heroSSR.home[0] ? "(max-width: 769px)" : "all",
      fetchpriority: "high",
    });
  useHead({ link: preloads });
}

useHead({
  templateParams: {
    subTitle: route.params.language == "en" ? "- bellaclub.com" : null,
    subPage:
      seo.value?.title ||
      (route.params.language == "pt-br"
        ? "Ensaios Sensuais, Fotos e Vídeos de Modelos Nuas"
        : "Sensual Photo Shoots, Photos & Videos of Brazilian Models"),
    page_url: canonical,
    page_description:
      seo.value?.description ||
      (route.params.language == "pt-br"
        ? `Ensaios sensuais, fotos e vídeos exclusivos das mais belas modelos brasileiras nuas. Maior revista masculina digital do Brasil, com transmissões ao vivo e conteúdo em 4K. Assine agora!`
        : `Exclusive sensual photo shoots, photos and videos of the most beautiful Brazilian models. Brazil's largest digital men's magazine, with live broadcasts and 4K content. Subscribe now!`),
    page_image: shareImage(seo.value?.image, destaqueSSR.value?.fixedThumb),
    page_keywords:
      seo.value?.keywords ||
      (route.params.language == "pt-br"
        ? "bella da semana, ensaios sensuais, modelos brasileiras nuas, fotos exclusivas, vídeos de modelos, revista masculina, modelos nuas, ensaio fotográfico sensual, lives de modelos, bela da semana, belladasemana"
        : "bella club, sensual photo shoots, naked brazilian models, exclusive photos, model videos, men's magazine, nude models, sensual photo shoot, model lives, bella da semana, bellaclub"),
    page_locale: route.params.language as string,
    page_url_pt: "https://belladasemana.com.br/pt-br",
    page_url_en: "https://belladasemana.com.br/en",
    page_canonical: canonical,
  },
});

onMounted(() => {
  getData();
});

async function getData() {
  getUltimosCards();
  getCardPrincipal();
  getPostsBlog();
  getBannerFreeTour1();
  getBannerFreeTour2();
  getRandomFiveModelsVideos();
  getCarouselLives();
  getHomepageVideoMakingOf();
}

definePageMeta({
  middleware: ["not-found-lang"],
});

// O destaque e os dois cards seguintes são sempre os que a API responder. Eles
// mudam a cada publicação de ensaio, e qualquer cópia guardada no navegador
// sobrevive à publicação: a aba mantém o que guardou, e o visitante fica com o
// ensaio da semana anterior no lugar do novo.
async function getCardPrincipal() {
  loading.value = true;
  api
    .get(
      `v1/home/getEssayPrimary?language=${
        route.params.language
      }&mobile=${isMobile()}`
    )
    .then(({ data }) => {
      data.cardPincipal.locale = route.params.language;
      cardPrincipal.value = data.cardPincipal;

      fixedThumb.value = data.cardPincipal?.fixedThumb;
    });
  loading.value = false;
}
async function getUltimosCards() {
  api
    .get(
      `v1/home/getEssaySecondary?language=${
        route.params.language
      }&mobile=${isMobile()}`
    )
    .then(({ data }) => {
      ultimosCards.value = data.ultimosCards;
    });
}
async function getPostsBlog(changeLanguage = false) {
  api
    .get(
      `v1/home/getBlogs?language=${route.params.language}&limit=${
        isMobile() ? 9 : 6
      }&mobile=${isMobile()}`
    )
    .then(({ data }) => {
      postBlogs.value = data.blogs;
    });
}
async function getBannerFreeTour1() {
  if (route.params.language == "pt-br") {
    bannerFreeTour1.value = {
      image: isMobile() ? ImgFreetour1PtMobile : ImgFreetour1Pt,
      url: `${route.params.language}/freetour`,
    };
  } else {
    bannerFreeTour1.value = {
      image: isMobile() ? ImgFreetour1EnMobile : ImgFreetour1En,
      url: `${route.params.language}/freetour`,
    };
  }
}
async function getBannerFreeTour2() {
  if (route.params.language == "pt-br") {
    bannerFreeTour2.value = {
      image: isMobile() ? ImgFreetour2PtMobile : ImgFreetour2Pt,
      url: `${route.params.language}/assine`,
    };
  } else {
    bannerFreeTour2.value = {
      image: isMobile() ? ImgFreetour2EnMobile : ImgFreetour2En,
      url: `${route.params.language}/assine`,
    };
  }
}
async function getRandomFiveModelsVideos() {
  api.get("v1/home/getRandomFiveModels").then(({ data }) => {
    posts.value = data.postsCarroselModels;
  });
}
async function getCarouselLives() {
  api.get("v1/home/getRandomFiveModelsLives").then(({ data }) => {
    postsLives.value = data.postsCarroselModels;
  });
}
async function getHomepageVideoMakingOf() {
  api.get("v1/home/getRandomFiveModelsMakingOf").then(({ data }) => {
    // preview pode vir ausente (backend só inclui a chave quando não-vazia).
    // Ele vem relativo (/storage/essay-live-videos/...): no domínio principal o
    // vídeo dá 403, então vai para o api. (como o teaser da home); o pôster, que
    // vem do admin., vai para o domínio principal (imagem, pela Cloudflare).
    makingOfPosts.value = (data.postsCarroselModels ?? [])
      .filter((p: any) => !!p.preview)
      .map((p: any) => ({
        ...p,
        preview: naOrigemDaApi(p.preview),
        cover: posterNoDominioPrincipal(p.cover),
      }));
  });
}
</script>

<style scoped>
.slot-body {
  margin-top: 64px !important;
  background-color: #fff !important;
}
/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .slot-body {
    margin-top: 65px !important;
    position: relative;
  }
  .models-section {
    position: relative;
    z-index: 1;
  }
  .lives-dark-block {
    background-color: #000;
  }
  .makingof-video-section {
    background-color: #000;
  }
  .videos-section {
    background: #F0F0F0;
  }
  .videos-section .dark-rounded {
    background-color: #000;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
  /* "tampa" cinza com cantos inferiores arredondados sobre o preto:
     o arredondamento fica no cinza (não no preto) e o preto aparece nos cantos */
  .videos-section .videos-gray-cap {
    height: 20px;
    background: #F0F0F0;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    /* folga para a metade inferior do BannerAreaGold, que flutua sobre esta
       fronteira: empurra só o título "VÍDEOS", o preto começa no mesmo ponto */
    margin-bottom: 100px;
  }
  .lives-section {
    background-color: #000;
  }
}
/* regras desktop: replica o bloco escuro do mobile */
@media screen and (min-width: 770px) {
  .videos-section {
    background: #fff;
  }
  .videos-section .dark-rounded {
    background-color: #000;
    overflow: hidden; /* BFC: evita vazar margin-collapse do título */
    position: relative;
    z-index: 1;
  }
  /* tampa SUPERIOR branca -> arredonda o topo do preto */
  .videos-section .videos-gray-cap {
    height: 24px;
    background: #fff;
    border-bottom-left-radius: 22px;
    border-bottom-right-radius: 22px;
    /* folga para a metade inferior do BannerAreaGold (ver comentário no mobile) */
    margin-bottom: 130px;
  }
  .makingof-video-section {
    background-color: #000;
  }
  .lives-section {
    background-color: #000;
  }
  /* banner: preto até o centro vertical da imagem, branco abaixo.
     O ponto de corte (56%) é ajustado para cair no meio da imagem do banner;
     gradiente e tampa inferior devem usar o MESMO valor. */
  .lives-dark-block {
    background: linear-gradient(to bottom, #000 0 60%, #fff 60%);
    position: relative;
    padding-top: 20px; /* espaço para a tampa inferior */
  }
  /* tampa INFERIOR branca -> arredonda a base do preto no ponto de corte */
  .lives-dark-block::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: calc(60% - 24px);
    height: 24px;
    background: #fff;
    border-top-left-radius: 22px;
    border-top-right-radius: 22px;
    z-index: 0; /* atrás da imagem do banner (que está no .container) */
  }
}

/* Tablet/iPad (770–1199px): no Blog os cards passam a ficar em fluxo (relative, no
   BlogBlock) e a seção ganha o gradiente preto→branco como no desktop. O espaçador
   branco BlockWhite — que no desktop serve de fundo aos cards absolutos — fica
   redundante e geraria um bloco branco vazio abaixo do Blog; ocultar nesta faixa.
   (Em >=1200px o layout segue absoluto e o espaçador é usado.) */
@media screen and (max-width: 769px) {
  .home-blog-spacer {
    display: none;
  }
}

@media screen and (min-width: 770px) and (max-width: 1199px) {
  .home-blog-spacer {
    display: none;
  }

  .lives-dark-block {
    background: linear-gradient(to bottom, #000 0 79%, #fff 79%);
  }

  .lives-dark-block::before {
    top: calc(80% - 24px);
  }

  /* o banner é mais baixo nesta faixa (container fluido) -> menos folga abaixo */
  .videos-section .videos-gray-cap {
    margin-bottom: 110px;
  }
}

</style>
